<template>
  <div class="w-100" :class="Noresposive ? '' : 'Tbl-Responsive'">
    <div class="w-100 m-3"></div>

    <div class="row">
      <div v-if="Search && NoSearch != true" class="col-lg-6 col-12 mb-2">
        <input class="form-control" placeholder="جستجو در جدول..." @input="Search" v-model="searchSample" />
      </div>
      <div v-if="Search && NoSearch != true" class="col-lg-6 col-12 mb-2">
        <div class="row">
          <div class="col-3">
            <div class="row">
              <div class="col-6">
                <button v-if="IsReport" @click="ReportGrid" class="btn btn-outline-warning ml-2"><i class="fad fa-print Pointer mt-1" style="font-size: 20px"></i></button>
              </div>
              <div class="col-6">
                <export-excel v-if="excel" :data="exceltable">
                  <button :data-title="'دانلود فایل اکسل '" class="btn btn-outline-warning ml-2">
                    <i class="fad fa-file-excel Pointer mt-1" id="DownloadExcel" style="font-size: 20px"> </i>
                  </button>
                </export-excel>
              </div>
            </div>
          </div>
          <div class="col-8">
            <slot name="MetaSlot"></slot>
          </div>
        </div>
      </div>
    </div>
    <table class="table table-bordered table-hover">
      <thead class="">
        <th v-if="hasRowNum">#</th>

        <th v-for="(header, index) in columns" :key="index" :id="'header-' + header.name" class="text-center">
          <span v-if="header.name == 'Selected'">
            <div class="item" style="margin-top: -20px">
              <div class="checkbox-rect">
                <input @click="addRemoveSelects($event, null)" type="checkbox" :id="'checkAll'" />
                <label for="checkAll"></label>
              </div>
            </div>
          </span>
          <span v-else>
            {{ header.label }}
            <a v-if="Sortable" @click="Sort(header.name)" class="float-left Pointer">
              <i v-if="header.name == SortName && Sortasc" class="fad fa-sort-up"></i>
              <i v-else-if="header.name == SortName && !Sortasc" class="fad fa-sort-down"></i>
              <i v-else class="fas fa-sort"></i>
            </a>
          </span>
        </th>

        <th class="text-center" v-if="action">عملیات</th>
      </thead>
      <tbody>
        <tr v-for="(post, j) in rows" class="border" :key="j" :class="post.tblCombogrp37AxarinVazeit == 1312 || post.tblCombogrp37AxarinVazeit == 1656 || post.tblCombogrp37AxarinVazeit == 1664 ? ' borderd' : ''">
          <td class="text-center" v-if="hasRowNum">{{ DefPage * PageNationNamber + j + 1 }}</td>
          <td v-for="(header, index) in columns" class="text-center" :key="index" style="position: relative">
            <span v-if="header.name == 'Selected'">
              <!-- <input  @click="addRemoveSelects($event)"
                                        class="xl-checkbox"
                                        type="checkbox" :id="'checkTest' + post.id" />       
                                        -->

              <div class="item">
                <div class="checkbox-rect">
                  <input @click="addRemoveSelects($event, post)" type="checkbox" :id="'checkTest' + post.id" />
                  <label :for="'checkTest' + post.id"></label>
                </div>
              </div>
              <!-- <input @click="addRemoveSelects(post)" class="" v-model="post.Selected" type="checkbox"> -->
            </span>
            <slot :name="header.name" :props="post" :indexRow="DefPage * PageNationNamber + j + 1">
              <span v-if="typeof post[header.name] != 'boolean'">{{ post[header.name] }}</span>
              <span v-else-if="header.name != 'Selected'">
                <span>
                  <h3>
                    <i v-if="post[header.name]" class="fas mt-2 fa-check-circle-o text-success"> </i>
                    <i v-else class="fas fa-times-circle-o mt-2 text-danger"></i>
                  </h3>
                </span>
              </span>
            </slot>
          </td>
          <td class="text-center" style="white-space: nowrap !important" v-if="action">
            <slot name="action-slot" :props="post"></slot>
          </td>
        </tr>
        <tr v-if="SumList && SumList.length > 0" class="hover-logo" style="background: var(--sidebar-action-bg)">
          <td v-if="hasRowNum"></td>
          <td v-for="(header, index) in columns" class="text-center" :key="index" style="position: relative">
            <span v-for="(item, index) in SumList" :key="index">
              <span v-if="item == header.name"> {{ Sum(item) }} </span>
            </span>
          </td>
          <td class="text-center" v-if="action"></td>
        </tr>
      </tbody>
    </table>
    <div class="mt-4 mb-4 text-center" v-if="ShowDetail && ShowDetail==true">
      <slot name="Detail"> </slot>
    </div>
    <div v-if="NoPagination != true" class="mt-4 mb-4 text-center">
      <span :class="DefPage <= 0 ? '' : 'Pointer'" @click="DefPage <= 0 ? '' : FirstPage()" data-title="صفحــه اول" class="badge badge-PageNation text-light"><i class="fad fa-chevron-double-right m-1 text-light"></i></span>
      <span :class="DefPage <= 0 ? '' : 'Pointer'" class="badge badge-PageNation mr-1 text-light" dir="ltr" @click="DefPage <= 0 ? '' : Back()" data-toggle="tooltip" data-placement="left" data-title="صفحه قبلی">
        <i class="fad fa-arrow-right m-1 text-light"></i>
      </span>

      <span class="mx-2">
        <span class="badge badge-ActivePage p-2">{{ DefPage + 1 }}</span> - {{ AllPage }}
      </span>

      <span :class="DefPage >= AllPage - 1 ? '' : 'Pointer'" class="badge badge-PageNation ml-1" dir="ltr" @click="DefPage >= AllPage - 1 ? '' : Next()" data-toggle="tooltip" data-placement="left" data-title="صفحه بعدی">
        <i class="fad fa-arrow-left m-1"></i>
      </span>
      <span :class="DefPage >= AllPage - 1 ? '' : 'Pointer'" data-title="صفحــه آخر" class="badge badge-PageNation text-light" @click="DefPage >= AllPage - 1 ? '' : LastPage()"><i class="fad fa-chevron-double-left m-1 text-light"></i></span>

      <select class="form-control Pages Pointer" v-model="PageNationNamber" @change="ChangePageNum($event)">
        <option value="5">5</option>
        <option value="10">10</option>
        <option value="15">15</option>
        <option value="20">20</option>
        <option value="30">30</option>
        <option value="50">50</option>
      </select>
    </div>
    <i></i>
  </div>
</template>
<script>
export default {
  data() {
    return {
      globalPageNum: 0,
      exceltable: [],
      MainRows: [],
      Searchinput: true,
      columns: [],
      Allrows: [],
      rows: [],
      AllPage: 0,
      DefPage: 0,
      selecteds: [],
      selectAll: false,
      searchSample: '',
      SortName: '',
      Sortasc: true,
      temp: [],
      PageNationNamber: 10,
    }
  },
  computed: {
    GetTheme() {
      return this.$store.state.ThemeLight == true
    },
    getwidth() {
      return window.innerWidth
    },
  },
  created() {
    this.PageNationNamber = this.pagenum ? this.pagenum : 10
    if (this.NoPagination == true) {
      this.PageNationNamber = 50
    }
    this.$store.state.CustomerTicketSortAndPage.PageNationNamber = this.PageNationNamber
    this.MainRows = JSON.parse(JSON.stringify(this.propsRows))
    if (this.SearchTable != undefined) {
      this.Searchinput = this.SearchTable
    }
    if (this.Selectable) {
      this.columns.push({ id: 555, name: 'Selected', visibility: true, width: 329, indexCol: 1, label: 'انتخاب' })
      for (let index = 0; index < this.MainRows.length; index++) {
        this.MainRows[index]['Selected'] = false
      }
    }

    /* if (this.hasRowNum) {
       this.columns.push({ id: 555, name: 'row', visibility: true, width: 329, indexCol: 1, label: '#' })
    } */
    for (let index = 0; index < this.propsColumn.length; index++) {
      // if (this.propsColumn[index].visibility && this.propsColumn[index].label !="") {
      if (this.propsColumn[index].visibility) {
        this.columns.push(this.propsColumn[index])
      }
    }

    for (let index = 0; index < this.MainRows.length; index++) {
      if (this.MainRows[index]['Id']) {
        this.MainRows[index]['id'] = this.MainRows[index]['Id']
      }
    }
    if (this.excel) {
      this.exelReport()
    }
    this.Allrows = JSON.parse(JSON.stringify(this.MainRows))
    this.temp = JSON.parse(JSON.stringify(this.Allrows))
    this.GetPageNation(this.Allrows)
  },
  props: ['action', 'excel', 'SearchTable', 'propsRows', 'Noresposive', 'propsColumn', 'hasRowNum', 'Selectable', 'CustomColumn', 'Sortable', 'SumList', 'pagenum', 'IsReport', 'HeaderReport', 'NoSearch', 'NoPagination', 'ListCommaReport','ShowDetail'],
  methods: {
    ChangePageNum(e) {
      this.searchSample = ''
      this.DefPage = 0
      this.PageNationNamber = Number(e.target.value)
      this.$store.state.CustomerTicketSortAndPage.PageNationNamber = this.PageNationNamber
      this.GetPageNation(this.MainRows)
    },
    Sum(key) {
      var sum = 0
      this.MainRows.forEach((element) => {
        sum += Math.floor(Number((element[key] + '').replace(/,/g, '')))
      })
      return this.$Comma3ragham(sum)
    },
    GetPageNation(data) {
      var pageNumber = this.PageNationNamber
      this.AllPage = Math.ceil(data.length / this.PageNationNamber)
      this.MainRows = data
      this.rows = data.slice(0, this.DefPage * pageNumber + pageNumber)
      this.$store.state.renderComponentCombo = false
      this.$nextTick(() => {
        this.$store.state.renderComponentCombo = true
      })
    },
    Next() {
      this.DefPage++
      var pageNumber = this.PageNationNamber
      this.globalPageNum = this.PageNationNamber
      this.rows = this.MainRows.slice(this.DefPage * pageNumber, this.DefPage * pageNumber + pageNumber)
      this.$store.state.renderComponentCombo = false
      if (this.$route.name == 'CustomerTicket') {
        this.$store.state.CustomerTicketSortAndPage.Page = this.DefPage
      }
      this.$nextTick(() => {
        this.$store.state.renderComponentCombo = true
        this.nextickSort()
      })
    },
    GoTOPage() {
      if (this.propsRows.length) {
      }
      var pageNumber = this.PageNationNamber
      this.globalPageNum = this.PageNationNamber
      this.rows = this.MainRows.slice(this.DefPage * pageNumber, this.DefPage * pageNumber + pageNumber)
      this.$store.state.renderComponentCombo = false
      if (this.$route.name == 'CustomerTicket') {
        this.$store.state.CustomerTicketSortAndPage.Page = this.DefPage
      }
      this.$nextTick(() => {
        this.$store.state.renderComponentCombo = true
        this.nextickSort()
      })
    },
    Back() {
      this.DefPage--
      var pageNumber = this.PageNationNamber
      this.rows = this.MainRows.slice(this.DefPage * pageNumber, this.DefPage * pageNumber + pageNumber)
      this.$store.state.renderComponentCombo = false
      if (this.$route.name == 'CustomerTicket') {
        this.$store.state.CustomerTicketSortAndPage.Page = this.DefPage
      }
      this.$nextTick(() => {
        this.$store.state.renderComponentCombo = true
        this.nextickSort()
      })
    },
    LastPage() {
      this.DefPage = this.AllPage
      var pageNumber = this.PageNationNamber

      this.DefPage = Math.ceil(this.MainRows.length / pageNumber) - 1
      if (this.$route.name == 'CustomerTicket') {
        this.$store.state.CustomerTicketSortAndPage.Page = this.DefPage
      }
      this.rows = this.MainRows.slice(this.DefPage * pageNumber, this.DefPage * pageNumber + pageNumber)
      this.$store.state.renderComponentCombo = false
      this.$nextTick(() => {
        this.$store.state.renderComponentCombo = true
        this.nextickSort()
      })
    },
    FirstPage() {
      this.DefPage = this.AllPage
      var pageNumber = this.PageNationNamber

      this.DefPage = 0
      if (this.$route.name == 'CustomerTicket') {
        this.$store.state.CustomerTicketSortAndPage.Page = this.DefPage
      }
      this.rows = this.MainRows.slice(this.DefPage * pageNumber, this.DefPage * pageNumber + pageNumber)
      this.$store.state.renderComponentCombo = false
      this.$nextTick(() => {
        this.$store.state.renderComponentCombo = true
        this.nextickSort()
      })
    },
    GetTypeOf(type) {
      if (typeof type != 'boolean') {
        return false
      } else {
        return true
      }
    },
    addRemoveSelects(e, data) {
      if (data == null) {
        this.selectAll = !this.selectAll
        this.rows.forEach((element) => {
          document.getElementById('checkTest' + element.id).checked = this.selectAll
          if (this.selectAll) {
            this.$emit('SelectedData', this.rows)
          } else {
            this.$emit('SelectedData', [])
          }
        })
      } else {
        if (e.target.checked) {
          this.selecteds.push(data)
        } else {
          var index = this.selecteds.indexOf(data)
          if (index >= 0) {
            this.selecteds.splice(this.selecteds.indexOf(data), 1)
          }
        }
        this.$emit('SelectedData', this.selecteds)
      }
    },
    Search() {
      this.temp = []
      this.Allrows.forEach((element) => {
        var sample = Object.values(element)
        // console.log(sample);
        for (let index = 0; index < sample.length; index++) {
          const samp = sample[index] + ''
          if (samp.indexOf(this.searchSample) > -1) {
            this.temp.push(element)
            break
          }
        }
      })
      this.DefPage = 0
      this.GetPageNation(this.temp)
      this.nextickSort()
    },
    nextickSort() {
      this.$store.state.renderComponentSort = false
      this.$nextTick(() => {
        this.$store.state.renderComponentSort = true
        this.$PutCommatoInput()
        if (this.excel) {
          this.exelReport()
        }
      })
    },
    Sort(cName, Frommounted) {
      if (!Frommounted) {
        if (this.SortName == null || this.SortName == '') {
          this.SortName = cName
        }
        if (this.SortName == cName) {
          this.Sortasc = !this.Sortasc
          this.SortName = cName
        } else {
          this.Sortasc = true
          this.SortName = cName
        }
        if (this.$route.name == 'CustomerTicket') {
          this.$store.state.CustomerTicketSortAndPage.sortAsc = this.Sortasc
          this.$store.state.CustomerTicketSortAndPage.sortName = this.SortName
        }
      } else {
        this.SortName = cName
        this.Sortasc = this.$store.state.CustomerTicketSortAndPage.sortAsc
      }
      this.temp = JSON.parse(JSON.stringify(this.Allrows))

      if (typeof this.temp[0][cName] == 'string') {
        if (this.Sortasc) {
          this.temp.sort((a, b) => (a[this.SortName] == null ? '' : a[this.SortName]).trim().localeCompare((b[this.SortName] == null ? '' : b[this.SortName]).trim()))
          this.nextickSort()
        } else {
          this.temp.sort((b, a) => (a[this.SortName] == null ? '' : a[this.SortName]).trim().localeCompare((b[this.SortName] == null ? '' : b[this.SortName]).trim()))
          this.nextickSort()
        }
      } else {
        if (this.Sortasc) {
          this.temp.sort((a, b) => {
            if (a[this.SortName] > b[this.SortName]) {
              this.nextickSort()

              return -1
            }
            if (a[this.SortName] < b[this.SortName]) {
              this.nextickSort()

              return 1
            }
            return 0
          })
        } else {
          this.temp.sort((a, b) => {
            if (a[this.SortName] < b[this.SortName]) {
              return -1
            }
            if (a[this.SortName] > b[this.SortName]) {
              return 1
            }
            return 0
          })
        }
      }
      this.MainRows = JSON.parse(JSON.stringify(this.temp))
      this.GetPageNation(this.MainRows)
    },
    ReportGrid() {
      //this.$toasted.info('درحال ایجاد گزارش ، ممکن است کمی زمان بر باشد لطفا منتظر بمانید ...',{duration:3000});
      this.$router.push({ name: 'Print', params: { Columns: this.propsColumn, Rows: this.MainRows, hasRowNum: this.hasRowNum, Header: this.HeaderReport, ListCommaReport: this.ListCommaReport } })
    },
    exelReport() {
      var ExcelColumns = []
      this.propsColumn.forEach((element) => {
        if (element.visibility) {
          ExcelColumns.push({ label: element.label, name: element.name })
        }
      })
      this.exceltable = []
      this.MainRows.forEach((element) => {
        var excelrow = {}
        ExcelColumns.forEach((col) => {
          excelrow[col.label] = element[col.name]
        })
        this.exceltable.push(excelrow)
      })
    },
  },
  mounted() {
    this.$PutCommatoInput()
    if (this.$route.name == 'CustomerTicket') {
      this.Sortasc = this.$store.state.CustomerTicketSortAndPage.sortAsc
      //  this.SortName=  this.$store.state.CustomerTicketSortAndPage.sortName
      var AllPage = Math.ceil(this.MainRows.length / this.$store.state.CustomerTicketSortAndPage.PageNationNamber)

      if (this.$store.state.CustomerTicketSortAndPage.Page > AllPage) {
        this.DefPage = 0
      } else {
        this.DefPage = this.$store.state.CustomerTicketSortAndPage.Page
      }
      this.Sort(this.$store.state.CustomerTicketSortAndPage.sortName, true)
      this.GoTOPage()
    }
  },
}
</script>
<style scoped>
.Pages {
  width: 10% !important;
  display: inline !important;
  margin-right: 6px;
  text-align: center !important;
}
.badge-PageNation {
  border: 1px solid rgb(136, 136, 136);
}
.badge-ActivePage {
  color: rgb(241, 146, 14) !important;
}

table {
  background: var(--table-background);
  color: var(--sidebar-color-item);
}
td {
  border-color: var(--table-border-color);
}
th {
  border-color: var(--table-border-color);
}
thead {
  border-color: var(--table-border-color) !important;
}
tr:hover {
  color: var(--sidebar-color-item) !important;
  background: var(--sidebar-bg-color) !important;
}
#header-Selected {
  width: 5% !important;
}
.borderd span:not(.fas):not(.fad) {
  color: rgb(253, 93, 8) !important;
}
.borderd a:not(.fas):not(.fad) {
  color: rgb(253, 93, 8) !important;
}
.hover-logo:hover {
  background: var(--logo-color) !important;
}
</style>
<style>
[data-title]:hover:after {
  opacity: 1;
  transition: all 0.1s ease 0.5s;
  visibility: visible;
}
[data-title]:after {
  content: attr(data-title);
  background-color: #000;
  color: #fff;
  font-size: normal;
  position: absolute;
  padding: 1px 5px 2px 5px;
  top: 2rem;
  left: 0;
  box-shadow: 1px 1px 3px #222222;
  opacity: 0;
  border: 1px solid #111111;
  border-radius: 5px;
  z-index: 99999;
  visibility: hidden;
}
[data-title] {
  position: relative;
}
.Tbl-Responsive {
  overflow-x: auto;
  overflow-y: visible !important;
}
</style>
